define("auth/templates/login", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#unless this.isKeycloak}}
    <LoginForm @authenticate={{this.authenticate}} @isSsoLogin={{this.isSsoLogin}} @ssoAppName={{this.ssoAppName}} />
  {{/unless}}
  
  <Shared::Mobile::Drawer::FeatureDrawer @closeModal={{this.closeFeatureDrawer}} @featureName={{this.featureLinkName}} />
  */
  {
    "id": "ISY6Yzzr",
    "block": "[[[41,[51,[30,0,[\"isKeycloak\"]]],[[[1,\"  \"],[8,[39,1],null,[[\"@authenticate\",\"@isSsoLogin\",\"@ssoAppName\"],[[30,0,[\"authenticate\"]],[30,0,[\"isSsoLogin\"]],[30,0,[\"ssoAppName\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[8,[39,2],null,[[\"@closeModal\",\"@featureName\"],[[30,0,[\"closeFeatureDrawer\"]],[30,0,[\"featureLinkName\"]]]],null]],[],false,[\"unless\",\"login-form\",\"shared/mobile/drawer/feature-drawer\"]]",
    "moduleName": "auth/templates/login.hbs",
    "isStrictMode": false
  });
});